<script lang="ts">
  import Portal from 'svelte-portal';
  import { clickoutside } from '@svelte-put/clickoutside';
  import { lockBodyScroll } from './actions/lock-body-scroll';

  export let open = false;
  export let onClose: Function | undefined = undefined;
  export let title: string = '';
  export let size: 'sm' | 'md' | 'lg' | 'xl' | 'full' = 'md';

  let parent: HTMLElement;

  function closeModal() {
    open = false;

    if (onClose) {
      onClose();
    }
  }

  let sizeClass = 'modal ';
  if (sizeClass !== 'full') {
    sizeClass += `modal-${size}`;
  }
</script>

{#if open}
  <Portal target="body">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div use:lockBodyScroll class={`${sizeClass} d-block`} tabindex="-1" bind:this={parent}>
      <div class="modal-dialog modal-dialog-centered" class:full-width={size === 'full'}>
        <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
        <div
          class="modal-content"
          on:click|stopPropagation
          use:clickoutside={{ limit: { parent } }}
          on:clickoutside={closeModal}
          role="dialog"
        >
          {#if $$slots.header}
            <div class="modal-header">
              {#if title}
                <h1 class="modal-title fs-5">{title}</h1>
              {:else}
                <slot name="header" />
              {/if}
              <button type="button" class="btn-close" aria-label="Close" on:click={closeModal} />
            </div>
          {/if}
          <div class="modal-body py-3 my-1">
            <slot name="body" />
          </div>
        </div>
      </div>
    </div>

    <div class="modal-backdrop show" />
  </Portal>
{/if}

<style>
  .btn-close {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  .full-width {
    max-width: none;
    padding: 0 16px;
  }
</style>
